export default __webpack_public_path__ + "static/media/product_freedom.474ae993.png";